import React, { useEffect, useState } from 'react'
import img from '../Institutions/assets/BANNER.jpg'
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../Config/Config';
export default function Departments() {
  // ================================================ Data fetching ============================================= //
  const [showData, setShowData] = useState([]);
  const fetchData = async () => {
    const q = query(collection(db, "departments"), orderBy("order", "asc"));
    const querySnapshot = await getDocs(q);
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setShowData(data);
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <div
        className="w-full mx-auto px-9 py-8 bg-cover bg-center"
        style={{ backgroundImage: `url(${img})` }}
      >
        <div className="flex items-center text-black">
          <a
            href="/"
            className="flex font-semibold text-lg items-center text-gray-900  transition-colors duration-300"
          >
            <svg
              className="w-4 h-4 mr-2"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
            </svg>
            Home
          </a>
          <span className="mx-2">/</span>
          <h2 className="text-[#881337]">DEPARTMENTS</h2>
        </div>
      </div>

      <div class="container mx-auto p-6 bg-gray-50 text-gray-900">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          {showData &&
            showData.map((data) => {
              return (
                <div class="relative bg-white p-6 rounded-lg border">
                  <div class="absolute inset-0 border-gradient-to-r from-[#881337] to-[#5a2222] rounded-lg"></div>
                  <div class="relative">
                    <div class="bg-gradient-to-r from-[#881337] to-[#5a2222] text-white py-2 px-4 rounded-t-lg">
                      <h2 class="text-xl font-bold">
                        {data.department_name.value}
                      </h2>
                    </div>
                    <div class="p-6 bg-white rounded-b-lg">
                      {Object.keys(data)
                        .sort(
                          (a, b) => (data[a].order || 0) - (data[b].order || 0)
                        )
                        .map((key, idx) => {
                          if (
                            key !== "id" &&
                            key !== "order" &&
                            key !== "listHeading" &&
                            key !==
                              data.listHeading
                                .toLowerCase()
                                .replace(/\s/g, "_") &&
                            key !== "department_name"
                          ) {
                            return (
                              <>
                                {key.toLowerCase() === "email" ? (
                                  <p class="text-gray-700 mb-2">
                                    <strong>
                                      {key.charAt(0).toUpperCase() +
                                        key.slice(1).toLowerCase()}
                                      :
                                    </strong>
                                    &nbsp;
                                    <a
                                      href={`mailto:${data[key].value}`}
                                      class="text-blue-600 underline"
                                    >
                                      {data[key].value}
                                    </a>
                                  </p>
                                ) : key.toLowerCase() === "contact" ? (
                                  <p class="text-gray-700 mb-2">
                                    <strong>
                                      {key.charAt(0).toUpperCase() +
                                        key.slice(1).toLowerCase()}
                                      :
                                    </strong>
                                    &nbsp;
                                    <a
                                      href="tel:+914952721748"
                                      class="text-blue-600 underline"
                                    >
                                      {data[key].value}
                                    </a>
                                  </p>
                                ) : key.toLowerCase() === "whatsapp" ? (
                                  <p class="text-gray-700 mb-2">
                                    <strong>
                                      {key.charAt(0).toUpperCase() +
                                        key.slice(1).toLowerCase()}
                                      :
                                    </strong>
                                    &nbsp;
                                    <a
                                      href={`https://wa.me/${data[
                                        key
                                      ].value.trim()}`}
                                      class="text-blue-600 underline"
                                    >
                                      {data[key].value}
                                    </a>
                                  </p>
                                ) : key.toLowerCase() === "telegram" ? (
                                  <p class="text-gray-700 mb-2">
                                    <strong>
                                      {key.charAt(0).toUpperCase() +
                                        key.slice(1).toLowerCase()}
                                      :
                                    </strong>
                                    &nbsp;
                                    <a
                                      href="https://t.me/9961757449"
                                      class="text-blue-600 underline"
                                    >
                                      {data[key].value}
                                    </a>
                                  </p>
                                ) : (
                                  <p class="text-gray-700 mb-2">
                                    <strong>
                                      {key
                                        .replace(/_/g, " ")
                                        .charAt(0)
                                        .toUpperCase() +
                                        key
                                          .replace(/_/g, " ")
                                          .slice(1)
                                          .toLowerCase()}
                                      :
                                    </strong>
                                    &nbsp;
                                    {data[key].value}
                                  </p>
                                )}
                              </>
                            );
                          }
                          return null;
                        })}
                      {data.listHeading ? (
                        <>
                          <h3 className="text-xl font-semibold text-[#881337] mt-6 mb-4">
                            {data.listHeading.toUpperCase()}
                          </h3>
                          <ul className="list-disc list-inside text-gray-700 space-y-2">
                            {Array.isArray(
                              data[
                                data.listHeading
                                  .toLowerCase()
                                  .replace(/\s/g, "_")
                              ]
                            ) &&
                              data[
                                data.listHeading
                                  .toLowerCase()
                                  .replace(/\s/g, "_")
                              ].map((li, index) => (
                                <li key={index}>{li}</li> 
                              ))}
                          </ul>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
